import { Navigate, Outlet } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../stores/authStore";
import { fetchUserProfileDetails } from "../../api/userProfileApi";

export function AuthGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [isChecking, setIsChecking] = useState(true);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    // Validate authentication on component mount
    const validateAuth = () => {
      const authState = useAuthStore.getState();
      const hasAuth = !!(authState.isAuthenticated && authState.user);
      setIsValid(hasAuth);
      setIsChecking(false);

      if (hasAuth && authState.user) {
        const currentUser = authState.user;
        const needsProfileFetch =
          (!currentUser.organizations || currentUser.organizations.length === 0) &&
          (!currentUser.groups || currentUser.groups.length === 0);

        if (needsProfileFetch) {
          fetchUserProfileDetails(currentUser)
            .then((details) => {
              useAuthStore.getState().setProfileDetails(details);
            })
            .catch(() => {});
        }
      }
    };

    // Small delay to ensure stores are initialized
    const timer = setTimeout(validateAuth, 0);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Listen for logout event (triggered by API 401 error)
    const handleLogout = () => {
      console.log("[AuthGuard] Logout event received, logging out user");
      useAuthStore.getState().logout();
      setIsValid(false);
    };

    window.addEventListener("user-logout", handleLogout);
    return () => window.removeEventListener("user-logout", handleLogout);
  }, []);

  // Show nothing while checking auth status
  if (isChecking) {
    return null;
  }

  if (!isAuthenticated || !isValid) {
    console.log("[AuthGuard] User not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
